import styled from '@emotion/styled';

const ImproveRecsHeader = styled('h2')(({ theme }) => ({
  fontWeight: 'bold',
  marginBottom: theme.dimensions.gutter,
}));

export default ImproveRecsHeader;
